import { computed, Ref } from '@vue/composition-api';
import { CountryCode } from '@front-app/services/SharedModels';

export const POSTAL_MASK_BY_COUNTRY_CODE: Record<CountryCode, string[]> = {
	['CA' as CountryCode]: ['A#A #A#'],
	['US' as CountryCode]: ['#####', '#####-####'],
};

export const usePostalMask = (country: Ref<CountryCode | null>): Ref<string[] | undefined> => computed(() => {
	if (country.value) {
		return POSTAL_MASK_BY_COUNTRY_CODE[country.value];
	}
	return undefined;
});
